// ─────────────────────────────────────────────────────────────
// Paleta corporativa para gráficas
// Fuente: identidad visual del cliente. NO modificar arbitrariamente.
// Reglas:
//   - Identidad principal: #15335B (azul), #E9560D (naranja), #F4AA27 (amarillo).
//   - 3+ categorías: incorporar progresivamente #2E5B88, #4E956B, #66558F, #3F8F95, #C9784D, #718092.
//   - Verde SOLO para crecimiento / cumplimiento / positivo (no asignarlo a categoría comercial).
//   - Naranja/amarillo = énfasis (que no compitan con el azul).
//   - Evolución temporal: mismo color para una misma métrica.
//   - Comparativas: tonos de la misma familia para la misma métrica en distinto escenario.
// ─────────────────────────────────────────────────────────────

export const PALETTE = {
  // Azules (identidad primaria)
  primaryDark: "#15335B", // azul profundo — serie principal, títulos, destacados
  primaryMedium: "#2E5B88", // azul medio — segunda serie, comparativos
  primaryLight: "#6F91B3", // azul cielo — tercera serie, fondos de apoyo
  // Naranjas
  orange: "#E9560D", // naranja corporativo — KPI destacado, variación
  terracotta: "#C9784D", // terracota — categorías secundarias
  // Amarillos
  yellow: "#F4AA27", // amarillo corporativo — tercera categoría, alertas positivas
  sand: "#E7C477", // arena — categorías secundarias
  // Verdes
  green: "#4E956B", // verde ejecutivo — crecimiento, positivo, cumplimiento
  sage: "#86B39A", // verde salvia — segunda categoría verde
  // Otros
  purple: "#66558F", // morado sobrio — categoría adicional
  turquoise: "#3F8F95", // turquesa — categoría adicional
  gray: "#718092", // gris azulado — otros / info secundaria
} as const;

// Secuencia progresiva para gráficas con 3+ categorías.
export const CHART_PALETTE = [
  PALETTE.primaryDark, // #15335B
  PALETTE.orange, // #E9560D
  PALETTE.yellow, // #F4AA27
  PALETTE.primaryMedium, // #2E5B88
  PALETTE.green, // #4E956B
  PALETTE.purple, // #66558F
  PALETTE.turquoise, // #3F8F95
  PALETTE.terracotta, // #C9784D
  PALETTE.gray, // #718092
  PALETTE.sand, // #E7C477
  PALETTE.sage, // #86B39A
  PALETTE.primaryLight, // #6F91B3
] as const;

// Colores fijos por canal de venta (una misma categoría mantiene su color).
export const CANAL_COLORS: Record<string, string> = {
  "En el local": PALETTE.primaryDark,
  Delivery: PALETTE.orange,
  "PICK UP": PALETTE.yellow,
  Rappi: PALETTE.terracotta,
  JUSTO: PALETTE.turquoise,
  Panguch: PALETTE.purple,
  "Take Out": PALETTE.primaryMedium,
  Market: PALETTE.gray,
  Empresas: PALETTE.gray,
  Retail: PALETTE.sage,
};

// Mapea una lista de categorías a colores: fijo por nombre si existe,
// si no, color de la secuencia progresiva por posición.
export function coloresPara(categorias: readonly string[]): string[] {
  return categorias.map(
    (c, i) => CANAL_COLORS[c] ?? CHART_PALETTE[i % CHART_PALETTE.length]
  );
}
